export default {
  en: {
    back: 'Back',
    next: 'Next',
    accept: 'Accept',
    loading: 'Loading',
    no: 'No',
    yes: 'Yes',
    cancel: 'Cancel',
    dateFormat: 'll',
    currency: 'NOK {num}',
    index: {
      login: 'Log in',
      buyLicense: 'Buy license',
      feide: {
        login: 'Log in with Feide'
      }
    },
    license: {
      contactForVolumePricing: 'School or other organization? Contact us for volume pricing at',
      whereToUse: 'Where will the apps be used?',
      useInternational: 'International',
      useNorway: 'In Norway',
      shoppingCart: 'Shopping Cart',
      addToCart: 'Add to cart',
      removeFromCart: 'Remove',
      individual: 'Private',
      institution: 'Institution',
      entity: 'Entity',
      courses: 'Courses',
      paymentInfo: 'Payment Information',
      license: 'License',
      number: 'License number',
      entityContent: 'Are you buying for private or institutional use?',
      coursesContent: 'Select which courses you want',
      paymentInfoContent: 'Enter your information',
      licenseContent: 'Order confirmation',
      subtotal: 'Subtotal',
      total: 'Total',
      totalPer: 'Per student',
      totalMva: 'Total incl VAT',
      student: 'student',
      students: 'students',
      studentsCap: 'Students',
      minimum20: 'minumum 20 students',
      rebate100: '10% discount when more than 100 students',
      askForInvoice: 'Ask for invoice',
      introductoryOffer: 'Introductory offer',
      introductoryOfferText: 'For the rest of the Norwegian schoolyear 2018/2019: 50 kr per student per course. 120 kr per student for the package deal.',
      packageOffer: 'Package offer',
      ofVAT: 'Of this, 25% VAT',
      VAT: 'VAT',
      form: {
        label: {
          name: 'Name',
          contact: 'Contact person',
          email: 'E-mail',
          org: 'Institution',
          orgnr: 'Org. nr.',
          ref: 'Your ref.',
          address: 'Address',
          city: 'City',
          country: 'Country',
          card: 'Credit Card',
          autoRenew: 'Should we auto-renew the subscription each period?',
          yes: 'Yes',
          no: 'No'
        },
        placeholder: {
          name: 'Enter your name',
          email: 'Enter your e-mail',
          org: 'Enter institution name',
          orgnr: 'Enter organization number',
          ref: 'Your ref.',
          address: 'Enter your address',
          zip: 'Enter your zip code',
          city: 'Enter your city',
          country: 'Select country'
        },
        error: {
          name: 'Name cannot be empty',
          email: 'E-mail cannot be empty',
          email2: 'Incorrect email format',
          org: 'Institution cannot be empty',
          orgnr: 'Organization number cannot be empty',
          address: 'Address cannot be empty',
          city: 'City cannot be empty',
          zip: 'Zip code cannot be empty',
          renew: 'You must choose an option',
          country: 'Please select country'
        },
        received: 'Your request has been received',
        termsLink: 'https://leaplearning.no/terms/#terms-of-purchase',
        acceptTerms: 'payment terms',
        acceptTerms1: 'I have read and accept the',
        acceptTerms2: 'and am aware that there is no right of withdrawal.',
      },
      period: {
        period: 'Period',
        semester: 'Spring 2019',
        year: "Schoolyear '19-'20",
      },
      term: {
        month: 'month',
        year: 'schoolyear',
        privmonth: 'month',
        privyear: 'year',
        semester: 'semester'
      },
      payment: {
        succeed: 'Payment successful!',
        receiptSent: 'Receipt and your license has been sent to your email address.',
        checkSpam: 'Make sure you check your spam-folder if you cannot find it.',
        youHaveAccess: 'You now have access to the following:',
        yourLicenseIs: 'Your license is:',
        alsoSentToEmail: 'This information has also been sent to your email.',
        gotoWebapps: 'Go to the webapps',

        error: 'Error',
        unfortunateError: 'Unfortunately an error occured while communicating with the payment processor.',
        engineerNotified: 'An engineer has been notified automatically and we\'re working to fix this.',
        contactUs: 'If you do not receive an email with your license within the hour,<br> \
          feel free to contact us at <a href="mailto:post@leaplearning.no">post@leaplearning.no</a> to further escalate the situation.',
      },
      complete: {
        thankYou: 'Thank you for your request!',
        manualHandling: 'We process your request manually.',
        invoiceIsSent: 'Invoice and license will be sent to the email address you provided within 1-3 business days.',
        weHaveRegistered: 'We registered following information:',
        whenYouReceive1: 'When you receive the license, you can go to',
        whenYouReceive2: 'and start using the apps.',
        whenYouReceive3: 'You will be asked to enter the license the first time you open an app on a device.',
        contactUs: 'Contact us',
        ifSomethingsIncorrect: 'if this information is not correct.',
      }
    },
    manage: {
      licenseInfo: 'License info',
      licenseType: 'License type',
      autoRenewal: 'Auto renew',
      email: 'Email',
      login: 'Username or email',
      expiration: 'Expiration',
      appCollections: 'Courses',
      paymentInfo: 'Payment information',
      invoices: 'Invoices',
      due: 'Due',
      paid: 'Paid',
      unpaid: 'Unpaid',
      adjust: 'Adjust',
      addCard: 'Add card',
      setAsDefault: 'Set as default',
      remove: 'Remove',
      areYouSure: 'Are you sure?',
      subscriptions: 'Subscription',
      manageThroughPortal: 'Manage your subscription, payment, and invoices through the Billing Portal ➔',
      cancelled: 'Cancelled',
      cancelSub: 'Cancel',
      to: "to",
      interval: {
        year: 'Yearly',
        month: 'Monthly',
        mixed: 'Mixed',
      },
      resources: {
        title: 'Training guide',
        available: 'Available files',
        allLanguages: 'All languages',
        appBooks: 'App/Task-books',
        facilitator: 'Facilitator',
        setup: 'Setup',
        entrepreneurship: 'Entrepreneurship',
        printouts: 'Printouts',
        hotspot: 'Hotspot documents',
      },
      manuals: {
        title: 'Manuals'
      },
      videos: {
        stations: 'Learning Lab Training Videos',
        setup: 'Setup Videos',
        introduction: 'Introduction',
        download: 'Download',
        hires: 'Hi-Res',
        lowres: 'Lo-Res',
      },
      feide: {
        groupsAccess: 'Groups with access',
        noGroups: 'No groups'
      }
    }
  },
  nb: {
    back: 'Tilbake',
    next: 'Neste',
    accept: 'Aksepter',
    loading: 'Laster',
    no: 'Nei',
    yes: 'Ja',
    cancel: 'Avbryt',
    dateFormat: 'D. MMM YYYY',
    currency: '{num} kr',
    index: {
      login: 'Logg inn',
      buyLicense: 'Kjøp lisens',
      feide: {
        login: 'Logg inn med Feide'
      }
    },
    license: {
      contactForVolumePricing: 'Skole eller organisasjon? Kontakt oss for volum-prising på',
      whereToUse: 'Hvor skal appene brukes?',
      useInternational: 'I utlandet',
      useNorway: 'I Norge',
      shoppingCart: 'Handlekurv',
      addToCart: 'Legg til',
      removeFromCart: 'Fjern',
      individual: 'Privat',
      institution: 'Institusjon',
      entity: 'Type',
      courses: 'Fag',
      paymentInfo: 'Betalingsinformasjon',
      license: 'Lisens',
      number: 'Lisensnummer',
      entityContent: 'Kjøper du for privat eller institusjonell bruk?',
      coursesContent: 'Velg hvilke fag du vil ha',
      paymentInfoContent: 'Skriv inn din informasjon',
      licenseContent: 'Ordrebekreftelse',
      subtotal: 'Subtotal',
      total: 'Totalt',
      totalPer: 'Pr elev',
      totalMva: 'Total inkl mva',
      student: 'elev',
      students: 'elever',
      studentsCap: 'Elever',
      minimum20: 'minst 20 elever',
      rebate100: '10% rabatt for mer enn 100 elever',
      askForInvoice: 'Be om faktura',
      introductoryOffer: 'Introduksjonstilbud',
      introductoryOfferText: 'For resten av skoleåret 2018/2019: 50 kr pr elev. 120 kr pr elev for pakketilbud.',
      packageOffer: 'Pakketilbud',
      ofVAT: 'Herav 25% MVA',
      VAT: 'MVA',
      form: {
        label: {
          name: 'Navn',
          contact: 'Kontaktperson',
          email: 'E-post',
          org: 'Institusjon',
          orgnr: 'Org. nr.',
          ref: 'Deres ref.',
          address: 'Adresse',
          city: 'Poststed',
          country: 'Land',
          card: 'Kredittkort',
          autoRenew: 'Skal abonnementet fornyes hver periode?',
          yes: 'Ja',
          no: 'Nei'
        },
        placeholder: {
          name: 'Skriv inn ditt navn',
          email: 'Skriv inn e-post',
          org: 'Skriv inn navn på institusjon',
          orgnr: 'Skriv inn organisasjonsnummer',
          ref: 'Deres ref.',
          address: 'Skriv inn adresse',
          zip: 'Skriv inn zip kode',
          city: 'Skriv inn poststed',
          country: 'Velg land'
        },
        error: {
          name: 'Navn kan ikke være tomt',
          email: 'E-post kan ikke være tomt',
          email2: 'Feil e-postformat',
          org: 'Institusjon kan ikke være tomt',
          orgnr: 'Organisasjonsnummer kan ikke være tomt',
          address: 'Adresse kan ikke være tomt',
          city: 'Poststed kan ikke være tomt',
          zip: 'Zip kode kan ikke være tom',
          renew: 'Du må velge et alternativ',
          country: 'Vennligst velg land'
        },
        received: 'Din forespørsel har blitt mottatt',
        termsLink: 'https://leaplearning.no/vilkaar/#terms-of-purchase',
        acceptTerms: 'kjøpsvilkårene',
        acceptTerms1: 'Jeg har lest og godtatt',
        acceptTerms2: 'og er klar over at det ikke er angrerett på dette kjøpet.',
      },
      period: {
        period: 'Periode',
        semester: 'Våren 2019',
        year: "Skoleåret '19-'20",
      },
      term: {
        month: 'måned',
        year: 'skoleår',
        privmonth: 'måned',
        privyear: 'år',
        semester: 'semester'
      },
      payment: {
        succeed: 'Betalingen var vellykket!',
        receiptSent: 'Kvittering og lisens er sendt til e-postadressen du oppgav.',
        checkSpam: 'Sjekk søppelpost-mappen dersom du ikke mottar noe.',
        youHaveAccess: 'Du har nå tilgang til følgende:',
        yourLicenseIs: 'Din lisens er som følger:',
        alsoSentToEmail: 'Denne informasjonen har også blitt sendt til din e-postadresse.',
        gotoWebapps: 'Gå til webappene',

        error: 'Feil',
        unfortunateError: 'Dessverre skjedde det en feil ved kommunikasjon med betalingstjenesten.',
        engineerNotified: 'En utvikler har blitt varslet automatisk, og vi jobber med å rette dette opp.',
        contactUs: 'Hvis du ikke mottar en epost med lisensinformasjon innen timen,<br> \
          kontakt oss på <a href="mailto:post@leaplearning.no">post@leaplearning.no</a> for å videre eskalere saken.',
      },
      complete: {
        thankYou: 'Tusen takk for din forespørsel!',
        manualHandling: 'Vi behandler din forespørsel manuelt.',
        invoiceIsSent: 'Faktura og lisens vil bli sendt til e-postadressen du oppgav innen 1-3 arbeidsdager.',
        weHaveRegistered: 'Vi har registrert følgende informasjon:',
        whenYouReceive1: 'Når du har fått lisensen, kan du gå til',
        whenYouReceive2: 'for å begynne å bruke appene.',
        whenYouReceive3: 'Du vil bli bedt om å oppgi lisensen når du åpner en app.',
        contactUs: 'Ta kontakt',
        ifSomethingsIncorrect: 'med oss dersom informasjonen ikke er korrekt!',
      }
    },
    manage: {
      licenseInfo: 'Lisensinfo',
      licenseType: 'Lisenstype',
      autoRenewal: 'Autofornyes',
      email: 'E-post',
      login: 'Brukernavn eller e-post',
      expiration: 'Gyldig til',
      appCollections: 'Fag',
      paymentInfo: 'Betalingsinformasjon',
      invoices: 'Faktura',
      due: 'Forfall',
      paid: 'Betalt',
      unpaid: 'Ubetalt',
      adjust: 'Justere',
      addCard: 'Legg til kort',
      setAsDefault: 'Sett som standard',
      remove: 'Fjern',
      areYouSure: 'Er du sikker?',
      subscriptions: 'Abonnement',
      manageThroughPortal: 'Administrer abonnement, betaling, og faktura gjennom Billing Portal ➔',
      cancelled: 'Kansellert',
      cancelSub: 'Kanseller',
      to: 'til',
      interval: {
        year: 'Årlig',
        month: 'Månedlig',
        mixed: 'Mikset',
      },
      resources: {
        title: 'Treningsguide',
        available: 'Tilgjengelige filer',
        allLanguages: 'Alle språk',
        appBooks: 'App-/Aktivitetsbøker',
        facilitator: 'Fasilitator',
        setup: 'Oppsett',
        printouts: 'Ressurser',
        hotspot: 'Hotspot dokumenter'
      },
      manuals: {
        title: 'Manualer'
      },
      videos: {
        stations: 'Learning Lab Treningsvideoer',
        setup: 'Oppsettsvideoer',
        introduction: 'Introduksjon',
        download: 'Last ned',
        hires: 'Hi-Res',
        lowres: 'Lo-Res',
      },
      feide: {
        groupsAccess: 'Grupper med tilgang',
        noGroups: 'Ingen grupper'
      }
    }
  },
}